import req from './request'

const DEFAULT_ENDPOINTS = {
    sms: '/communications/sms',
    reference: '/communications/telephony/reference',
    operatorList: '/communications/telephony/operator-list'
}

export default {
    sms(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.sms, param)
    },
    reference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reference, param)
    },
    operatorList(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.operatorList, param)
    },

}

